'use client';

import { useState } from 'react'

import Button from "@src/components/century-21-or-company/button"
import ModalSuccess from "@src/components/century-21-or-company/modal-success"
import FormJoin from "@src/components/homepage/form-join"

const YourFuture = () => {
  const [isOpenForm, setIsOpenForm] = useState(false);
  const [isOpenModalSuccess, setIsOpenModalSuccess] = useState(false);

  const onOpenForm = () => {
    setIsOpenForm(true)
  }
  const onCloseForm = () => {
    setIsOpenForm(false)
  }
  const handleOpenModalSuccess = () => {
    onCloseForm()
    setIsOpenModalSuccess(true)
  }
  const handleCloseModalSuccess = () => {
    setIsOpenModalSuccess(false)
  }

  return (
    <div className='main-wrapper py-[104px] bg-white 
    dd-lg:py-[80px]'>
      <div className='content-wrapper grid grid-cols-2 gap-x-6 
        dd-xl:flex dd-xl:flex-col items-center dd-xl:grid-cols-[unset] dd-xl:gap-x-[unset]'>
        <div className='w-[560px] h-[560px] border border-solid border-grey-0 rounded-[24px] 
            dd-2xl:w-[440px] dd-2xl:h-[440px] 
            dd-xl:mb-6 dd-xl:w-[648px] dd-xl:h-[648px] 
            dd-lg:w-[400px] dd-lg:h-[400px]
            dd-md:w-[327px] dd-md:h-[327px]
            dd-sm:w-full'>
          <img
            className='w-full h-full object-cover rounded-[24px]'
            src={"https://s3.ap-southeast-1.amazonaws.com/production.storages/storages/store/franchise-asset/never-stop.png"}
            alt={"never-stop"}
          />
        </div>


        <div className="flex flex-col justify-center 
          dd-xl:items-center">
          <p className='mb-6 text-64 font-sfpro-bold text-black-1 
              dd-xl:text-44 dd-xl:text-center'>Kami Menunggu <span className='font-sfpro'>Anda!</span></p>

          <p className='text-17 font-sfpro text-black-1 mb-[40px]
              dd-xl:text-center'>Mulailah atau tingkatkan karier Anda di bidang properti dengan berbagai ksesmpatan komprehensif kami. Jelajahi berbagai peran, mulai dari penjualan hingga administrasi. Bergabunglah dengan tim yang mendukung dan mulailah perjalanan menuju kesuksesan di industri properti.</p>

          <Button
            onClick={onOpenForm}
            className='!bg-white-3 border border-solid border-black-1 
            hover:!bg-black-1 hover:!text-white-3'
            text="GABUNG BERSAMA KAMI"
          />
        </div>
      </div>

      <FormJoin onSuccess={handleOpenModalSuccess} onClose={onCloseForm} isOpen={isOpenForm}/>
      <ModalSuccess
        isOpen={isOpenModalSuccess}
        title="Permintaan Telah Terkirim!"
        description="Terima kasih telah mempercayakan karir Anda kepada CENTURY 21 Indonesia"
        onClose={handleCloseModalSuccess}
      />
    </div>
  )
}

export default YourFuture